const zoomCache = new WeakMap();
export function createProjectionProviderPlugin({ getProjectionChart, onProjectionInstall }) {
    let skipNextUpdate = false;
    return {
        id: 'provideProjectionChart',
        install(chart) {
            zoomCache.set(chart, {
                min: null,
                max: null,
            });
        },
        afterDataLimits(chart, { scale }) {
            if (scale.id !== 'x') {
                return;
            }
            const zoom = zoomCache.get(chart);
            if (zoom.min !== null) {
                scale.min = zoom.min;
            }
            if (zoom.max !== null) {
                scale.max = zoom.max;
            }
        },
        afterUpdate(chart) {
            if (skipNextUpdate) {
                skipNextUpdate = false;
                return;
            }
            const projectionChart = getProjectionChart();
            if (!projectionChart) {
                onProjectionInstall((createdProjectionChart) => {
                    updateProjectionConfig(chart, createdProjectionChart);
                });
                return;
            }
            updateProjectionConfig(chart, projectionChart);
            projectionChart.update('none');
        },
    };
}
function updateProjectionConfig(chart, projectionChart) {
    const projectionChartConfig = projectionChart.config;
    const linearScalesIds = [];
    Object.keys(chart.scales)
        .forEach((scaleId) => {
        const scale = chart.scales[scaleId];
        if (scale.type === 'linear' && !scale.isHorizontal() && scale.options.display !== false) {
            linearScalesIds.push(scaleId);
        }
    });
    const { datasets } = chart.data;
    const metas = datasets.map((dataset, datasetIndex) => {
        const meta = chart.getDatasetMeta(datasetIndex);
        if (meta.type !== 'line') {
            return null;
        }
        if (!meta.yAxisID) {
            return null;
        }
        if (meta.hidden) {
            return null;
        }
        if (!linearScalesIds.includes(meta.yAxisID)) {
            return null;
        }
        const scale = chart.scales[meta.yAxisID];
        return {
            datasetIndex,
            dataset: dataset,
            meta,
            scaleId: meta.yAxisID,
            scale,
        };
    })
        .filter((meta) => meta !== null);
    const yScales = {};
    metas.forEach((meta) => {
        yScales[meta.scaleId] = {
            display: false,
            ticks: {
                display: false,
            },
            grid: {
                display: false,
            },
        };
    });
    projectionChartConfig.data.labels = chart.data.labels;
    projectionChartConfig.data.datasets = metas.map((meta) => ({
        label: meta.dataset.label,
        data: meta.dataset.data,
        borderWidth: 2,
        borderColor: 'rgba(52,143,168,0.73)',
        backgroundColor: 'rgba(43,148,173,0.71)',
        pointRadius: 0,
        fill: 'start',
    }));
    projectionChartConfig.options.scales = {
        x: {
            type: 'linear',
            ticks: {
                display: false,
            },
            grid: {
                display: false,
            },
        },
        y: {
            display: false,
            ticks: {
                display: false,
            },
        },
        ...yScales,
    };
    projectionChartConfig.options.plugins.legend = {
        display: false,
    };
    projectionChartConfig.options.plugins.projectionChart.onSliderChange = (sliders) => {
        const zoomed = zoomCache.get(chart);
        zoomed.min = sliders.left;
        zoomed.max = sliders.right;
        chart.update();
    };
    if (chart.chartArea) {
        const originalPadding = chart.options.layout?.padding;
        const originalLeftPadding = checkPadding(originalPadding, 'left');
        const originalRightPadding = checkPadding(originalPadding, 'right');
        let leftPadding = originalLeftPadding;
        let rightPadding = originalRightPadding;
        linearScalesIds.forEach((key) => {
            const scale = chart.scales[key];
            if (scale.position === 'left') {
                leftPadding += scale.width;
            }
            else {
                rightPadding += scale.width;
            }
        });
        projectionChartConfig.options.layout.padding = {
            left: leftPadding,
            right: rightPadding,
        };
    }
}
function checkPadding(padding, side) {
    if (typeof padding === 'number') {
        return padding;
    }
    if (typeof padding === 'object') {
        return padding[side];
    }
    return 0;
}
//# sourceMappingURL=projectionProvider.js.map
